import styled from "styled-components";
import { Select } from "antd";

const { Option } = Select

interface SelectProps {
    readonly ischanged: boolean;
    readonly isselected: boolean;
}

export const StyledBasedSelect = styled(Select).attrs(props => ({
    backgroundcolor: props["ischanged"]
        ? "rgba(189, 54, 54, 0.1)"
        : props["isselected"]
            ? "white"
            : "rgba(98, 147, 97, 0.1)"
}))<SelectProps>`
    width: 100%;


    .ant-select-selector {
        background-color: ${props => props.backgroundcolor} !important;
        border-color: white !important;
        border-radius: 4px !important;

    }

    .ant-select-focused {
        border-color: white !important;
    }


    .ant-select-selection {
        background-color: ${props => props.backgroundcolor} !important;
        border-radius: 4px !important;

    }

    .ant-select:not(.ant-select-customize-input) .ant-select-selector {
        background-color: ${props => props.backgroundcolor} !important;
    }
`;

export const BasedOption = styled(Option)`
    .ant-select-item {
        color: red;
    }

    .ant-select-item .ant-select-item-option .custom-option .ant-select-item-option-active {
        background-color: red !important;
    }

    .ant-select-item-option-active:not(.ant-select-item-option-disabled) {
        background-color: red !important;
    }

    .ant-select-item-option-content:hover {
        font-weight: bold;
    }
`;

